const footLinks = [
  { href: '#news', label: '追踪快讯' },
  { href: '#timeline', label: '焦点时间线' },
  { href: '#evidence', label: '实锤库' },
  { href: '#review', label: '复盘合集' },
  { href: '#index', label: '线索索引' },
  { href: '#about', label: '站点说明' },
];

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-start">
          <div className="max-w-sm">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-foreground-950">
                <i className="ri-search-eye-line text-base text-background-50" />
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">cg51</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              一条吃瓜线索从模糊到清晰的过程，值得被认真对待。持续深挖、如实讨论、缓慢复盘。
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold tracking-widest uppercase text-secondary-700">站内索引</p>
            <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-3">
              {footLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-300/70 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p className="whitespace-nowrap">© 2026 cg51 · 线索深挖与复盘索引</p>
          <p className="text-foreground-500">收录线索 39 条 · 本页为静态信息整理，仅供追踪参考</p>
        </div>
      </div>
    </footer>
  );
}